import React from 'react'
import classNames from 'classnames';



import CancelButton from '../loadingButton/modelCancelButton'
import SubmitButton from '../loadingButton/modelSubmitButton'
import SkipButton from '../loadingButton/skipButton'


const DashBoardContainer = (props)=>{


    return(
        <div
            style={{
                padding: props.borderLess ? 0 : ''
                }}
            className={ classNames("dashboard-container", {'disabled-side-bar': props.loader === true}) }>
            <div className="container-dash"
                style={{
                    padding: props.borderLess ? 0 : '',
                    border: props.borderLess ? 'none' : ''
                }}>
                {props.children}
            </div>
            <div 
                className="d-flex dashboard-footer-buttons"
                style={{
                    padding: props.borderLess ? '20px 40px' : '',
                }}
                >
               {!props.hasButton && 
               <>
                <CancelButton 
                    title="Back"
                    submit={props.handleCancel}/>
               {!props.hasmiddleBtn && <SkipButton 
                    title={props.middleTitle}
                    submit={props.handleSaveForLater}
                    disabled={props.disabled}/>}
                <SubmitButton
                    title={props.title}
                    submit={props.handleSubmit}
                    disabled={props.payLoader || props.isFetching}/>
               </>}
               {props.hasCloseBtn && <div style={{display: 'flex', margin: 'auto'}}>
                   <div style={{marginRight: '30px'}}>
                        <CancelButton 
                            title="Cancel"
                            submit={props.handleCloseMembership}/>
                   </div>
               
                <SubmitButton 
                    title={props.closeTitle}
                    submit={props.handleClose}
                    disabled={props.editLoader}
                    />

            </div>}
            </div>
           
        </div>
    )

}
export default DashBoardContainer